module.exports = __webpack_public_path__ + "img/visa.76fd3da4.svg";